import { PageHeader } from '@/components/layout/PageHeader'

export function BillingSettingsPage() {
  return (
    <div className="flex flex-col gap-8 p-8">
      <PageHeader title="Manage your subscription and billing information" />
    </div>
  )
}
